/**
 * Format date to Australian format DD/MM/YYYY
 */
export const formatAUDate = (date: Date | string | null | undefined): string => {
  if (!date) return '';
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

/**
 * Parse Australian date string (DD/MM/YYYY) to Date object
 */
export const parseAUDate = (dateString: string): Date => {
  const [day, month, year] = dateString.split('/').map(Number);
  return new Date(year, month - 1, day);
};

/**
 * Get date input value in YYYY-MM-DD format for HTML date inputs
 */
export const toDateInputValue = (date: Date | string | null | undefined): string => {
  if (!date) return '';
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Format datetime to Australian format DD/MM/YYYY HH:MM AM/PM
 */
export const formatAUDatetime = (date: Date | string | null | undefined): string => {
  if (!date) return '';
  const d = new Date(date);
  const datePart = formatAUDate(d);
  const hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12;
  return `${datePart} ${hours12}:${minutes} ${ampm}`;
};
